import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import { useWindowResize } from '@utils/domUtils'

import styles from './ModalGrid.module.scss'

interface ModalColumnProps extends PropsWithChildren {
  noPadding?: boolean
}

const ModalColumn: React.FC<ModalColumnProps> = (props) => {
  const { children, noPadding } = props
  const isMobile = useWindowResize()

  if (isMobile) return children

  return (
    <div
      className={classNames(styles.modalColumn, {
        [styles.noPadding]: noPadding,
      })}
    >
      {children}
    </div>
  )
}

interface ModalRowProps extends PropsWithChildren {
  layout?: '1-1' | '1-2' | '2-1' | '1-3' | '3-1'
  noGap?: boolean
}

const ModalRow: React.FC<ModalRowProps> = (props) => {
  const { children, layout = '1-1', noGap = false } = props
  const isMobile = useWindowResize()

  if (isMobile) return children

  return (
    <div
      className={classNames(styles.modalRow, styles[`layout-${layout}`], {
        [styles.noGap]: noGap,
      })}
    >
      {children}
    </div>
  )
}

export const ModalGrid = {
  Column: ModalColumn,
  Row: ModalRow,
}
